import {DialogManager} from "./components/dialog";
import {LogoManager} from "./components/logo";
import {BasketCountLoader} from "./components/basketCount";
import {ErrorReporter} from "./common/errorReporter";
import {CrossSellingSlider} from "./components/crossselling";
import {ClxIdChanger} from "./components/clxChangeId";
import {DropTrigger} from "./components/dropTrigger";
import {AnchorScrollHandler} from "./components/anchorScrollHandler";
import OpenLayer from './components/vertragsVerlaengerung/openLayer';

new LogoManager();
new BasketCountLoader();
new CrossSellingSlider();
new ErrorReporter();
new DialogManager();
new ClxIdChanger();
new DropTrigger();
new AnchorScrollHandler();
new OpenLayer();
